import { configureStore } from "@reduxjs/toolkit";
import { authApi, authSlice } from "@modules/auth";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { productApi, productSlice } from "@modules/product";
import { workApi, workSlice } from "@modules/work";
import { imageApi } from "@modules/images";
import { messageApi, messageSlice } from "@modules/messages";
import { markApi, markSlice } from "@modules/mark";
import { marketApi, marketSlice } from "@modules/market";
import { blogApi, blogSlice } from "@modules/blog";
import { recipeApi, recipeSlice } from "@modules/recipe";
import { ingredientApi } from "@modules/ingredient";
import { teamApi, teamSlice } from "@modules/team";
import { faqApi, faqSlice } from "@modules/faq";
import { configApi, configSlice } from "@modules/config";
import { categoryApi } from "@modules/category";

const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    product: productSlice.reducer,
    blog: blogSlice.reducer,
    recipe: recipeSlice.reducer,
    work: workSlice.reducer,
    message: messageSlice.reducer,
    mark: markSlice.reducer,
    market: marketSlice.reducer,
    team: teamSlice.reducer,
    faq: faqSlice.reducer,
    config: configSlice.reducer,
    [ingredientApi.reducerPath]: ingredientApi.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer,
    [imageApi.reducerPath]: imageApi.reducer,
    [productApi.reducerPath]: productApi.reducer,
    [blogApi.reducerPath]: blogApi.reducer,
    [recipeApi.reducerPath]: recipeApi.reducer,
    [workApi.reducerPath]: workApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [messageApi.reducerPath]: messageApi.reducer,
    [markApi.reducerPath]: markApi.reducer,
    [marketApi.reducerPath]: marketApi.reducer,
    [teamApi.reducerPath]: teamApi.reducer,
    [faqApi.reducerPath]: faqApi.reducer,
    [configApi.reducerPath]: configApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      blogApi.middleware,
      ingredientApi.middleware,
      categoryApi.middleware,
      recipeApi.middleware,
      imageApi.middleware,
      authApi.middleware,
      productApi.middleware,
      workApi.middleware,
      messageApi.middleware,
      markApi.middleware,
      marketApi.middleware,
      teamApi.middleware,
      faqApi.middleware,
      configApi.middleware
    ]),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
